import { useState } from 'react'

import { UpsellRequestResponseDialog } from '@factorialco/f0-react'
import { AvailableModules } from 'generated/featureDefinitions'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { useCreateUpsellRequestWithErrorHandling } from 'modules/upselling_kit/hooks/useCreateUpsellRequest'

interface UseMarketplaceUpsellRequestProps {
  moduleSlug?: string
  moduleRequested?: AvailableModules
  requestSource: string
  pageSource: string
}

export const useMarketplaceUpsellRequest = ({
  moduleSlug,
  moduleRequested,
  requestSource,
  pageSource,
}: UseMarketplaceUpsellRequestProps) => {
  const [upsellDialogOpen, setUpsellDialogOpen] = useState(false)
  const [upsellSuccess, setUpsellSuccess] = useState(false)
  const { create } = useCreateUpsellRequestWithErrorHandling()

  const handleUpsellSuccess = () => {
    setUpsellDialogOpen(true)
    setUpsellSuccess(true)
  }

  const handleUpsellError = () => {
    setUpsellDialogOpen(true)
    setUpsellSuccess(false)
  }

  const handleUpsellClose = () => {
    setUpsellDialogOpen(false)
    setUpsellSuccess(false)
  }

  const executeUpsellRequest = async () => {
    track(trackingEvents.upsell.requestUpsell, {
      source: requestSource,
      component: 'upselling_button',
      module: moduleSlug,
    })

    try {
      await create({
        moduleRequested: moduleRequested,
        requestSource,
        requestReason: ValidReasons.MissingAddon,
        pageSource,
      })
      handleUpsellSuccess()
    } catch (error) {
      handleUpsellError()
    }
  }

  const UpsellDialog = () => (
    <UpsellRequestResponseDialog
      open={upsellDialogOpen}
      success={upsellSuccess}
      portalContainer={document.getElementById('root')}
      errorMessage={{
        title: i18n.t('upselling_kit.upselling_button.error_message.title'),
        description: i18n.t('upselling_kit.upselling_button.error_message.description'),
      }}
      successMessage={{
        title: i18n.t('upselling_kit.upselling_button.success_message.title_2'),
        description: i18n.t('upselling_kit.upselling_button.success_message.description'),
      }}
      closeLabel={i18n.t('upselling_kit.upselling_button.close_label')}
      onClose={handleUpsellClose}
    />
  )

  return {
    executeUpsellRequest,
    UpsellDialog,
    isDialogOpen: upsellDialogOpen,
    isSuccess: upsellSuccess,
  }
}
